import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function EngleskiJezik1() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Engleski jezik 1" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Engleski jezik 1</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Engleski jezik 1
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Engleski jezik 1 je uvod u engleski jezik pravne struke. Ovaj
                kurs ne zahtjeva prethodno poznavanje engleske pravne
                terminologije ali prethodno stečena pravna znanja mogu biti
                korisna. Osnovni cilj nastave engleskog jezika struke je
                obnavljanje osnovnih gramatičkih struktura ovladavanje osnovnom
                opštom pravnom terminologijom nadgradnja jezičkih sistema
                razvijanje svih integrisanih jezičkih veština i
                socijalno-komunikacijskih kompetencija za potrebe daljeg
                studiranja i budućeg pravnog poziva. Nastavne teme obrađuju se
                kroz komparativan pristup pravnim sistemima (anglo-američki i
                kontinentalni).
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Po završetku kursa studenti će biti u stanju da: primjene
                osnovne jezičke veštine strategije i tehnike čitanja i
                razumjevanja teksta, slušanja i razumevanja usmenog izlaganja,
                pisanja kraćih formi, identifikuju adekvatne gramatičke
                strukture, razumiju objasne ili definišu osnovne pravne pojmove
                koriste adekvatnu opštu pravnu terminologiju u diskusijama
                simulacijama analizi ili rešavanju problema, klasifikuju
                sistematizuju i sumiraju ključne informacije iz teksta i
                primjene ih u analizi diskusiji dijalogu/razmjeni informacija
                rezimiranju slučajeva ili rješavanju problema, iskažu svoje
                mišljenje stav ili gledište i adekvatno reaguju u osnovnim
                socijalnim situacijama, tumače šematske prikaze tabele slike u
                cilju opisivanja istih u usmenoj/pisanoj formi, sumiraju tekst u
                usmenoj/pisanoj formi organizuju pisani sastav u paragrafe na
                osnovu adekvatne strukture i daju odgovore u okviru vođenog
                pisanog sastava.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Course Orientation; Needs Analysis; Listening & Social English:
                Introducing oneself and others; Speaking: The Study of Law
                (curriculum courses degrees/titles) Learner skills: Developing
                Listening Skills; Pronunciation: Syllables & Word Stress;
                Pronunciation: English Sounds: Vowels Diphtongs Consonants;
                Grammar: The Indefinite & Definite Articles; Learner skills:
                Developing Reading Skills: Harvard law School; HW Writing:
                E-mail letter of Inquiry (Summer School); Speaking & Listening:
                Law and Justice; Lg. focus: Collocations Confusing legal terms;
                Understanding definitions; Grammar: Modal Verbs; Lg. Functions:
                Expressing Opinions Clarifying ideas Agreeing/Disagreeing; Case
                study: Reading /Discussion: Miscarriage of Justice; Syntax:
                Linkers (Conjunctions); Writing: Opinion Essay: Paragraph
                writing (Capital Punishment); Writing: Academic
                standards/citation etc.; Speaking: Lawyer Skills: Profile
                Professional Skills Ethics and Responsibility;
                Listening/Reading: Lawyer Education in the UK Interview with a
                Solicitor; Legal Skills/Case study: Client Interview and Legal
                Counceling; Grammar: Present Tenses; Lg Function: Legal Advice
                Justifying a point of view; Pronunciation: Silent Letters;
                Writing: Writing a Legal Memo; Speaking: Legal Systems The Tree
                of Law: Branches of law; Sources of law; Lg. Focus: Confusing
                legal terms Collocations; Vocabulary: Legal Latin; Public
                Speaking: Giving a Presentation; Pronunciation: Sentence
                Intonation Patterns; Listening/Reading (note-taking
                summarizing): Statutory vs. Common law; Equity; Word building:
                Noun & Adjective Compounds; Learner Skills: Persuasive
                Argumentation (Jury Trial); Writing: Argumentative Essays (pro
                and con arguments); Speaking: Court participants; the Jury; Lg.
                Focus: Confusing legal terms; Reading & Understanding the Chart:
                The Court System in Britain; Grammar: Conditional Sentences
                (Zero 1st 2nd); Judicial Ethics & Responsibility; Lg focus:
                Words with Multiple meanings; Collocations with Prepositions
                Minimal pairs; HW Reading: Court System in the USA; (Descriptive
                Essay); Reading/Listening & Vocabulary: Courts of Appeal;
                Speaking: Democracy & Human Rights: Constitutional Rights and
                Freedoms (cases); Word Building: Negative Prefixes; Lg. focus:
                Legal terms collocations synonyms; Writing: Language of
                Argumentation Argumentative Essays; Speaking: Describing the
                Chart (Structure of the US Federal Government); Reading: The
                Legislative Branch (Picture story: the Law-making Process);
                Listening: The Executive Branch (Presidential Election; Chart:
                Checks and Balances; Lg focus: Prepositions Collocations
                Compounds; Words with multiple meanings; Grammar: Infinitive vs.
                Gerund; Pronunciation: British and American English; Listening:
                The British Parliament; Syntax: Sentence Linkers/The Role of the
                Monarch; Legal Terms/Vocabulary: Parliamentary Elections in
                Britain; Lg. Focus: Prepositions; Phrasal verbs; Pronunciation:
                Stress shift.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava engleskog jezika pravne stuke zasnovana je na osnovnim
                principima interaktivne nastave i razvijanju integrisanih
                jezičkih vještina i sistema kao i podsticanju samostalnog učenja
                studenata. Osnovni oblici rada na predmetu su: predavanje,
                vježbe, konsultacije, drugi vidovi nastave. Vidovi rada: timski,
                grupni, u parovima, individualni rad u manjim grupama. Nastavne
                tehnike: klasifikacija, kategorizacija, sistematizacija znanja i
                informacija; tumačenje tabela, šematskih prikaza, slika;
                diskusije, debate; analiza slučajeva, rješavanje problema,
                igranje uloga, simulacije, uporedna analiza pravnih sistema,
                mini-prezentacije, pisanje i dr.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>
                      Course Orientation; Needs Analysis; Listening & Social
                      English: Introducing oneself and others
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>
                      Speaking: The Study of Law (curriculum courses
                      degrees/titles); Learner skills: Developing Listening
                      Skills; Pronunciation: Syllables & Word Stress;
                      Pronunciation: English Sounds: Vowels Diphtongs Consonants
                      (Pre-U+ U1)
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>
                      Grammar: The Indefinite & Definite Articles; Learner
                      skills: Developing Reading Skills: Harvard law School; HW
                      Writing: E-mail letter of Inquiry (Summer School)
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>
                      Speaking & Listening: Law and Justice; Lg. focus:
                      Collocations Confusing legal terms; Understanding
                      definitions; Grammar: Modal Verbs; Lg. Functions:
                      Expressing Opinions Clarifying ideas Agreeing/Disagreeing
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>
                      Case study: Reading /Discussion: Miscarriage of Justice;
                      Syntax: Linkers (Conjunctions); Writing: Opinion Essay:
                      Paragraph writing (Capital Punishment); Writing: Academic
                      standards/citation etc.; Speaking: Lawyer Skills: Profile
                      Professional Skills Ethics and Responsibility;
                      Listening/Reading: Lawyer Education in the UK Interview
                      with a Solicitor
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>3P + 2V</td>
                    <td>KOLOKVIJUM I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>
                      Legal Skills/Case study: Client Interview and Legal
                      Counceling; Grammar: Present Tenses; Lg Function: Legal
                      Advice Justifying a point of view; Pronunciation: Silent
                      Letters; Writing: Writing a Legal Memo
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Speaking: Legal Systems The Tree of Law: Branches of law;
                      Sources of law; Lg. Focus: Confusing legal terms
                      Collocations; Vocabulary: Legal Latin
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>
                      Public Speaking: Giving a Presentation; Pronunciation:
                      Sentence Intonation Patterns; Listening/Reading
                      (note-taking summarizing): Statutory vs. Common law;
                      Equity; Word building: Noun & Adjective Compounds
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>
                      Learner Skills: Persuasive Argumentation (Jury Trial);
                      Writing: Argumentative Essays (pro and con arguments);
                      Speaking: Court participants; the Jury; Lg. Focus:
                      Confusing legal terms; Reading & Understanding the Chart:
                      The Court System in Britain; Grammar: Conditional
                      Sentences (Zero 1st 2nd); Judicial Ethics &
                      Responsibility; Lg focus: Words with Multiple meanings;
                      Collocations with Prepositions Minimal pairs
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>
                      HW Reading: Court System in the USA; (Descriptive Essay);
                      Reading/Listening & Vocabulary: Courts of Appeal;
                      Speaking: Democracy & Human Rights: Constitutional Rights
                      and Freedoms (cases); Word Building: Negative Prefixes;
                      Lg. focus: Legal terms collocations synonyms
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>3P + 2V</td>
                    <td>KOLOKVIJUM II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Writing: Language of Argumentation Argumentative Essays;
                      Speaking: Describing the Chart (Structure of the US
                      Federal Government); Reading: The Legislative Branch
                      (Picture story: the Law-making Process)
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Listening: The Executive Branch (Presidential Election;
                      Chart: Checks and Balances; Lg focus: Prepositions
                      Collocations Compounds; Words with multiple meanings
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>
                      Grammar: Infinitive vs. Gerund; Pronunciation: British and
                      American English; Listening: The British Parliament;
                      Syntax: Sentence Linkers/The Role of the Monarch; Legal
                      Terms/Vocabulary: Parliamentary Elections in Britain; Lg.
                      Focus: Prepositions; Phrasal verbs; Pronunciation: Stress
                      shift
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 3.45h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 1.3h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EngleskiJezik1;
